import { client } from './client'

export interface UploadedFileMetadata {
  blobPath: string
  fileName: string
  contentType: string
  sizeBytes: number
}

export interface UploadWorkflowRunFilesResponse {
  files: UploadedFileMetadata[]
}

export const workflowRunFilesApi = {
  upload: (projectId: string, files: File[]) => {
    const formData = new FormData()
    files.forEach(file => formData.append('files', file))

    return client
      .post<UploadWorkflowRunFilesResponse>(
        `/projects/${projectId}/workflow-run-files/upload`,
        formData,
        { headers: { 'Content-Type': undefined } }
      )
      .then(r => r.data)
  },

  delete: (projectId: string, blobPath: string) =>
    client.delete(`/projects/${projectId}/workflow-run-files`, {
      params: { blobPath },
    }).then(r => r.data),
}
